import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";
import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";

export default defineNuxtRouteMiddleware(async (_unused_to, _unused_from) => {
  console.debug("userIsCompanyAdmin middleware");
  const userStore = useUserStore();
  const companyStore = useCompanyStore();

  await companyStore.ensureLoaded();

  if (!userStore.isCompanyAdmin && companyStore.userCompany) {
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Not Company Admin`,
      body: `You are not a company admin.`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo(
      "/users/" +
        userStore.authUserUuid +
        "/company/" +
        companyStore.userCompany?.id +
        "/profile",
    );
  }
});
